module.exports = __webpack_public_path__ + "static/media/tomo.7b35ddd3.svg";